<template>
  <v-container
    fluid
    class="pa-0 custom-container"
    v-loading.fullscreen.lock="termofservice.isLoading"
  >
    <el-container class="category-title my-2">Edit Term of Service</el-container>
    <el-row>
      <el-col :span="12">
        <el-form
          label-position="left"
          ref="form"
          label-width="120px"
          :model="termofservice.termofservice"
        >
          <Form :TermOfService="termofservice.termofservice"></Form>

          <el-col>
            <el-form-item>
              <el-button type="primary" @click="save">Simpan</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>

    <br />
  </v-container>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      termofservice: state => state.termofservice
    })
  },
  methods: {
    ...mapActions({
      getTermOfService: "termofservice/GetTermOfService",
      updateTermOfService: "termofservice/UpdateTermOfService"
    }),
    save() {
      if (this.$refs.form.validate()) {
        this.updateTermOfService(this.termofservice.termofservice);
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getTermOfService();
  }
};
</script>

<style>
</style>
